import CarTopCategoryContainer from "../../../components/car/other/CarTopCategory";

const CarTopCategory = () => {
  return <CarTopCategoryContainer />;
};

export default CarTopCategory;
